module.exports = __webpack_public_path__ + "static/media/clubs-app.798dc5c1.svg";